export { default } from "./SkeletonPlayerDetailContainer";
